import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";

import './GrillasStyles.css';
import authContext from "../../context/authentication/authContex";
import activoContext from "../../context/activoContex/activoContex";
import informesContext from "../../context/informesContext/informesContext";
import normalizeText from "../../utils/normalizeText";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeftLong,
  faDownload,
  faTableCells
} from "@fortawesome/free-solid-svg-icons";
import SearchInput from "../searchInput/SearchInput";
import AddFilter from "../addFilter/AddFilter";
import FilterScreen from "../filterScreen/FilterScreen";
import usuariosContext from "../../context/usuarios/usuariosContext";
import SelectColumns from "./SelectColumns";
import Table from "./Table";
import { activosXreportsContext } from "../../context/activosXreportsContext/activosXreportsContext";

const GrillaControlServicios = ({setGridToShow}) => {

    const aContext = useContext(authContext);
    const { usuario } = aContext;

    const acContext = useContext(activoContext);
    const { getControlServiciosReporte } = acContext;

    const uContext = useContext(usuariosContext);
    const { saveColumnsPreferences } = uContext;

    const iContext = useContext(informesContext);
    const { generarInformeExcel } = iContext;

    const {saveField, getFieldsByReport} = useContext(activosXreportsContext);

    const dataRef = useRef(undefined);
    const alreadyLoaded = useRef(false);
    const [dataFiltered, setDataFiltered] = useState(undefined);
    const [filter, setFilter] = useState('');
    const [showSelectColumns, setShowSelectColumns] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [selct, setSelec] = useState([]);
    const [loading, setLoading] = useState(true);

    // const servSolicitadoTimerRef = useRef(null);
    // const comentarioTimerRef = useRef(null);
    const timers = useRef({});

    let columnsPreferences = useMemo(() => usuario?.columnsPreferences?.columnasControlServicios ?? [], [usuario]);

    const handleChangeServSolicitado = useCallback( async (index, value, act) => {
        let newData = dataRef?.current;
        
        if(newData.length > 0) newData = newData.map((a,i) =>  i == index ? {...a, servicioSolicitado: value} : a);
        
        dataRef.current = newData;

        setDataFiltered(newData);
        
        let key = `${index}_${'servicioSolicitado'}`;

        // clearTimeout(servSolicitadoTimerRef.current);
        clearTimeout(timers.current[key]);

        // servSolicitadoTimerRef.current[key] = setTimeout(async () => {
        timers.current[key] = setTimeout(async () => {
            
            let fieldToSave = {
                codActivo: act.codActivo,
                prop: 'servicioSolicitado',
                value: value,
                fecMod: new Date(),
                userName: usuario.userName,
                reportName: 'ControlServicios',
                activoID: act.id,
                comUserID: usuario._id
            }

            let res = await saveField(fieldToSave);
            delete timers.current[key];
        }, 3000);
    },[dataFiltered])
    
    const handleChangeComentarios = useCallback( async (index, value, act) => {
        let newData = dataRef?.current;
        
        if(newData.length > 0) newData = newData.map((a,i) =>  i == index ? {...a, comentarios: value} : a);
        
        dataRef.current = newData;

        setDataFiltered(newData);

        let key = `${index}_${'comentarios'}`;
        
        // clearTimeout(comentarioTimerRef.current[key]);
        clearTimeout(timers.current[key]);

        // comentarioTimerRef.current[key] = setTimeout(async () => {
        timers.current[key] = setTimeout(async () => {
            
            let fieldToSave = {
                codActivo: act.codActivo,
                prop: 'comentarios',
                value: value,
                fecMod: new Date(),
                userName: usuario.userName,
                reportName: 'ControlServicios',
                activoID: act.id,
                comUserID: usuario._id
            }
            let res = await saveField(fieldToSave);
            delete timers.current[key];
        }, 3000)
    },[dataFiltered])
    

    const [columns, setColumns] = useState([
        { width: 150, property: 'codActivo', title: 'Equipo', visible: true },
        { width: 200, property: 'name', title: 'Descripción', visible: true },
        { width: 200, property: 'hsUltimoServicio', title: 'HS Últ. Servicio', visible: true },
        { width: 200, property: 'fechaUltimoServicio', title: 'Fecha Últ. Servicio', visible: true },
        { width: 250, property: 'ultimoServicioNombre', title: 'Último Servicio Realizado', visible: true },
        { width: 200, property: 'ultimoRegistroHs', title: 'Último Registro de HS', visible: true },
        { width: 200, property: 'diferenciaHoras', title: 'Diferencia de Horas', visible: true },
        { width: 200, property: 'fechaUltimoRegistro', title: 'Fecha Últ. Registro', visible: true },
        { width: 200, property: 'fechaUltimoChecklist', title: 'Fecha Últ. Checklist', visible: true },
        { width: 200, property: 'diasTranscurridos', title: 'Días Transcurridos', visible: true },
        { width: 500, property: 'servicioSolicitado', title: 'Servicio Solicitado', setter: handleChangeServSolicitado, visible: true },
        { width: 500, property: 'comentarios', title: 'Comentarios', setter: handleChangeComentarios, visible: true },
    ]);

   

    const formatDate = (dateStr) => {
        if (!dateStr) return '-';
        return dateStr.toString().substring(0, 10);
    };

    const fetchData = (activosCod = []) => {
        setLoading(true);
        getControlServiciosReporte(activosCod)
        .then(res => {
            if (res.data) {
                dataRef.current = res.data;
                setDataFiltered(res.data);
                setLoading(false);
            }
        });
    };

    const apFiltros = (filtrosProp) => {
        const activosCod = filtrosProp.filterEstado?.activos || [];
        fetchData(activosCod);
    };

    const handleGenerarInforme = async () => {
        let dataToExcel = [];
        let columnsTitle = columns.filter(c => c.visible).map(c => c.title);
        dataToExcel.push(columnsTitle);

        for (const row of dataFiltered) {
            let rowData = [];
            for (const col of columns) {
                if (!col.visible) continue;
                const value = row[col.property];

                if (col.property === 'fechaUltimoServicio' || col.property === 'fechaUltimoRegistro' || col.property === 'fechaUltimoChecklist') {
                    rowData.push(formatDate(value));
                } else {
                    rowData.push(value ?? '-');
                }
            }
            if (rowData.length > 0) dataToExcel.push(rowData);
        }
        await generarInformeExcel(dataToExcel, 'ControlServicios');
    };

    const handleChangeColumnsVisible = (e, c, i) => {
        setColumns((prevCols) => prevCols.map((c, index) => index == i ? { ...c, visible: e.target.checked } : c));
    };

    useEffect(() => {
        if (filter != '') {
            if (!loading) {
                const nFilter = normalizeText(filter);
                let filtered = dataRef.current.filter(a =>
                    normalizeText(a.codActivo).includes(nFilter) || normalizeText(a.name).includes(nFilter)
                );
                setDataFiltered(filtered);
            }
        } else {
            setDataFiltered(dataRef.current != undefined ? dataRef.current : undefined);
        }
    }, [filter]);

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (columnsPreferences && columnsPreferences.length > 0 && !loading) {
            setColumns(prevColumns => prevColumns.map(c => ({ ...c, visible: columnsPreferences.includes(c.property) })));
        }
    }, [columnsPreferences, loading]);

    return <div className="grillaInformeDiv">
        <div className="utilitiesDiv">
            <button onClick={() => setGridToShow('')} className="goBackBtn"><FontAwesomeIcon className="iconArrowBack" icon={faArrowLeftLong} /></button>
            <SearchInput filter={filter} buscar={setFilter} />
            <FilterScreen verFiltro={setShowFilters} />
            <button className="selectColumnsBtn" onClick={() => setShowSelectColumns(true)}><FontAwesomeIcon className="iconArrowBack" icon={faTableCells} /></button>
            <button disabled={loading || dataFiltered == undefined || dataFiltered.length == 0} className="downloadBtn" onClick={handleGenerarInforme}>Descargar .xlsx <FontAwesomeIcon className="iconArrowBack" icon={faDownload} /></button>
        </div>
        {
            (dataFiltered == undefined || loading)
                ? <h3 className="warningStatusMsg">Cargando<span>.</span><span>.</span><span>.</span></h3>
                : (dataFiltered.length == 0)
                    ? <h3 className="warningStatusMsg">No hay datos de control de servicios</h3>
                    : <Table array={dataFiltered} columns={columns} setColumns={setColumns} />
        }
        {
            showSelectColumns && <SelectColumns setShowSelectColumns={setShowSelectColumns} handleChangeColumnsVisible={handleChangeColumnsVisible} columns={columns} saveColumnsPreferences={saveColumnsPreferences} usuario={usuario} columnsName={"ControlServicios"} />
        }
        {showFilters &&
            <div className="addFilterContainer">
                <AddFilter
                    usuarios={[]}
                    cerrar={() => setShowFilters(false)}
                    filtro={{filtrosEstado: {state: [], priority: [], userName: [], activos: [], tipoActivos: [], origenes: [], tipoAlerta: [], statesProcedimientos: [], tipoProcedimientos: [], statesChecklist: []}, filtrosRango: {fecAlt: {desde: new Date('2020-01-01'), hasta: new Date()}}}}
                    aplicarFiltros={apFiltros}
                    workspace={{}}
                    selct={selct}
                    setSelec={setSelec}
                    componentePadre="ControlServicios"
                />
            </div>
        }
    </div>
}

export default GrillaControlServicios;
